import { FaqList } from '@/components/FaqList'
import { Layout } from '@/components/Layout'

/**
 * Account-facing FAQs page (RSCX-353): RescueX-curated platform guidance.
 * The nav item only appears when at least one FAQ is published.
 */
const Faqs = () => (
  <Layout breadcrumbs={['FAQs']}>
    <Layout.Heading title="FAQs" />
    <div className="mt-4">
      <FaqList />
    </div>
  </Layout>
)

export default Faqs
